// src/api/axios.js
// ─────────────────────────────────────────────────────────────────────────────
//  Central Axios instance.
//  - withCredentials: true  → sends the HTTP-only cookie on every request
//  - Response interceptor   → auto-redirect to /login on 401/403
// ─────────────────────────────────────────────────────────────────────────────

import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://scms.infotechitsolutionsbd.com/',
  withCredentials: true,   // ← MUST be true to send/receive cookies cross-origin
  headers: {
    'Content-Type': 'application/json',
  },
});

// ── Response interceptor ──────────────────────────────────────────────────────
api.interceptors.response.use(
  // success – just pass through
  (response) => response,

  // error – handle auth failures globally
  (error) => {
    const status = error.response?.status;

    // 401: unauthenticated → login. 403 may be "permission denied" while still logged in.
    if (status === 401) {
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
